import { render, staticRenderFns } from "./batchPopup.vue?vue&type=template&id=32151fda&scoped=true&"
import script from "./batchPopup.vue?vue&type=script&lang=js&"
export * from "./batchPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32151fda",
  null
  
)

export default component.exports